import React from "react";

export const SignOut = ({ color = "#000000" }) => (
  <svg
    width="90"
    height="91"
    viewBox="0 0 90 91"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="45" cy="45.5" r="45" fill="#0073E0" fill-opacity="0.08" />
    <path
      d="M50.5 55.8125C50.3651 59.2077 47.5357 62.0905 43.7453 61.9978C42.8635 61.9762 41.7736 61.6688 39.5937 61.0539C34.3476 59.5742 29.7935 57.0873 28.7009 51.5162C28.5 50.4921 28.5 49.3397 28.5 47.035L28.5 43.965C28.5 41.6603 28.5 40.5079 28.7009 39.4838C29.7935 33.9127 34.3476 31.4258 39.5937 29.946C41.7736 29.3312 42.8635 29.0237 43.7453 29.0022C47.5357 28.9095 50.3651 31.7923 50.5 35.1875"
      stroke="#0073E0"
      stroke-width="2.75"
      stroke-linecap="round"
    />
    <path
      d="M61.5 45.4993H41.3333M61.5 45.4993C61.5 44.2156 57.8438 41.8172 56.9166 40.916M61.5 45.4993C61.5 46.7831 57.8438 49.1815 56.9166 50.0827"
      stroke="#0073E0"
      stroke-width="2.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
